import { SwiperOptions } from 'swiper/types';

/**
 * Transpose une grille ngu-carousel vers les breakpoints Swiper.
 *
 * ngu-carousel appliquait `xs` en dessous de 768px puis `sm`, `md` et `lg`
 * à partir de 768, 992 et 1200px. Swiper raisonne en min-width, la
 * correspondance est donc directe. Les valeurs fractionnaires (1.2, 2.6…)
 * sont conservées : elles laissent volontairement entrevoir la carte
 * suivante, ce qui sert de repère de défilement sur mobile.
 */
export function gridToBreakpoints(grid: {
  xs: number;
  sm: number;
  md: number;
  lg: number;
}): SwiperOptions['breakpoints'] {
  return {
    0: { slidesPerView: grid.xs },
    768: { slidesPerView: grid.sm },
    992: { slidesPerView: grid.md },
    1200: { slidesPerView: grid.lg }
  };
}
